export function formatPublicationDate(
    value?: string | null,
    preserveYearSpacing = false
): string {
    if (!value) return ''
    const text = new Date(value)
        .toLocaleDateString('ru-RU', {
            timeZone: 'Europe/Moscow',
            year: 'numeric',
            month: 'long',
        })
        .replace(preserveYearSpacing ? 'г.' : ' г.', '')
    return text.replace(text[0], text[0].toUpperCase())
}
